import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import * as XLSX from "xlsx"

import closeIcon from "../../../assets/common/close.svg"
import deleteIcon from "../../../assets/common/delete.svg"
import fileIcon from "../../../assets/common/fileIcon.svg"
import info_white from "../../../assets/common/Info_white.svg"
import tick_white from "../../../assets/common/tick_white.svg"
import uploadIcon from "../../../assets/common/upload.svg"
import uploadIconInactive from "../../../assets/common/upload-inactive.svg"
import ToastNotification, { notify } from "../../../components/Toast"
import {
    UploadFilesToModule,
    UploadFilesToModuleV2
} from "../../../services/mutations.js"
import { defaultLanguageId } from "../../../utils/Constant"
import { customNotification } from "../../../utils/utils.js"

const FileUploderWithDragandDrop = (props) => {
    const { t } = useTranslation()
    const {
        fileData,
        onUpload,
        formats,
        uploaderLabel,
        filesSupportLabel,
        sendFileAsBinary,
        count,
        onDelete,
        module,
        isCustomStyling,
        setIsUploadClicked,
        disabled,
        customFileName,
        useNewApiforUpload,
        bulkTicketID,
        orderManagementUpload,
        serviceCenterId,
        customerNumber
    } = props

    const DropContainer = useRef(null)
    const RemoveButton = useRef(null)
    const readers = useRef(null)
    const [dragging, setDragging] = useState(false)
    const [isUploading, setisUploading] = useState(false)
    const [isInvalidFormat, setisInvalidFormat] = useState(false)
    const [validFileName, setValidFileName] = useState("")
    const [InvalidfileName, setInvalidfileName] = useState("")
    const [isuploadCompleted, setisuploadCompleted] = useState(false)
    const [progress, setprogress] = useState(0)
    const supportedFormates = {
        "Excel": ["vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xls"],
        "Pdf": ["pdf"],
        "mp4": ["mp4"],      
        "zip": ["x-zip-compressed"],
        "plain": ["plain"]
    }
    const { mutateAsync: uploadByModule } = useNewApiforUpload ? UploadFilesToModuleV2() :  UploadFilesToModule()
    let selectedFormat = ""
    Object.keys(supportedFormates).forEach((key) => {
        const compareArray = supportedFormates[key]
        const isMatched = compareArray.every((element) => formats.filter(x => x === element).length > 0)
        if (isMatched) {
            selectedFormat+= selectedFormat ? ", " +key : key
        }

    })
  
    const FileRef = useRef(null)
    const clearRef = useRef(null)

    const loginDetails = sessionStorage.getItem("userDetails")
    const { user_details } = JSON.parse(loginDetails || {})
    
    const resetUploader = () => {
        clearTimeout(clearRef.current)
        clearRef.current = null
        readers.current?.map((reader) => {
            reader?.abort()
        })
        FileRef.current.value = null
        setisUploading(false)
        setisInvalidFormat("")
        setValidFileName("")
        setisuploadCompleted(false)
        setprogress(0)
        if (onDelete) {
            onDelete()
        }
    }

    const updateProgressBar = (completed, total, error) => {
        const progress = Math.round(completed / total * 100)
        setprogress(progress)
        if (progress === 100) {
            if(error) {
                notify("ERROR", customNotification(error, t))
                setisUploading(false)
                setisuploadCompleted(false)
                setisInvalidFormat(false)
            }
            else{
                setTimeout(()=>{
                    setisUploading(false)
                    setisuploadCompleted(true)
                },1000)
            }
            clearRef.current = setTimeout(() => {
                resetUploader()
            }, 5000)
        }
    }

    const progressPromise = (promises, progressCallback) => {
        const len = promises.length
        let progress = 0
        let errorMsg = ""

        function makeCompleted(promise) {
            promise.then(function () {
                progress++
                progressCallback(progress, len, errorMsg)
            }).catch((ex) => {
                errorMsg += `${ex?.message}`
                progress++
                progressCallback(progress, len, errorMsg)
            })
            return promise
        }

        return Promise.all(promises.map(makeCompleted)).catch(() => {
        })
    }

    const upload = (files) => {
        if ((files && files.length > 0) || files?.name) {
            // const fileSize =  files[0]?.size
            // const FILE_SIZE = Math.floor(fileSize / 1024) // Kbyte
            /* if(FILE_SIZE > 501)
            {
                notify("ERROR",  t("common.totalFileSizeError"))
            }
            else {*/
            let uploadFiles = []
            if(!Array.isArray(files)){
                uploadFiles.push(files)
            }else{
                uploadFiles = files
            }
            setisUploading(true)
            if(sendFileAsBinary){
                let fileNames = ""
                uploadFiles.map(async (file) => {
                    let fileName = file?.name
                    if(customFileName && customFileName?.length) {
                        let split = fileName.split(".")
                        let fileExtension = split.pop()
                        let newFileName = split.join(".")
                        fileName = newFileName + "-" + customFileName + "." + fileExtension
                    }
                    fileNames += fileNames.length > 0 ? ", " + fileName : fileName
                })
                setValidFileName(fileNames)
                onUpload(uploadFiles)
                setisUploading(false)
                setisuploadCompleted(true)
            }else{
                let fileNames = ""
                if (module) {
                    const nFiles = uploadFiles.map(async (file) => {
                        let fileName = file?.name
                        if(customFileName && customFileName?.length) {
                            let split = fileName.split(".")
                            let fileExtension = split.pop()
                            let newFileName = split.join(".")
                            if(module === "serviceCenterUpload"){
                                fileName = newFileName + "-" + customerNumber + "." + fileExtension
                            }
                            else{
                                fileName = newFileName + "-" + customFileName + "." + fileExtension
                            }
                            console.log(fileName)
                        }
                        fileNames += fileNames.length > 0 ? ", " + fileName : fileName
                        setValidFileName(fileNames)
                        const newFile = customFileName && customFileName?.length ? new File([file], fileName, { type: file.type }) : ""
                        const formData = new FormData()
                        formData.append("file", newFile || file)
                        formData.append("module", module)
                        bulkTicketID && formData.append("bulk_id", bulkTicketID)
                        bulkTicketID && formData.append("country_id", user_details?.country_id)
                        bulkTicketID && formData.append("language_id", defaultLanguageId)
                        serviceCenterId && formData.append("entityId", serviceCenterId)
                        appendAddtionalDetailsBymodule(formData)
                        if(orderManagementUpload){
                            let result = await uploadByModule(formData)
                            onUpload(result)
                            return result
                        }else{
                            return uploadByModule(formData)
                        }
                    })
                    progressPromise(nFiles, updateProgressBar)

                } else {
                    const readersarr = []
                    const totalFiles = uploadFiles.length
                    let currentSize = 0
                    const totalSize =  uploadFiles.reduce((acc, file) => acc + file?.size, 0)
                    const nFiles = uploadFiles.map(async (file) => {
                        fileNames += fileNames.length > 0 ? ", " + file?.name : file?.name
                        setValidFileName(fileNames)
                        const data = await readFileData(file, readersarr, totalFiles, totalSize, currentSize)
                        return {
                            name: file.name,
                            content: data,
                            type: file.type,
                            size: file.size
                        }
                    })
                    readers.current = readersarr
                    Promise.all(nFiles).then((newFiles) => {
                        readers.current = null
                        onUpload(newFiles)
                    })
                }

            }
            //}
        }
    }

    const appendAddtionalDetailsBymodule = (formData) => {
        if (useNewApiforUpload) {
            switch (module) {
            case "WarantyTicketBulkUpload":
                if (user_details?.country_id) {
                    formData.append("country_id", user_details?.country_id)
                }
                formData.append("language_id", defaultLanguageId)
                break
            }
        }
    }

    const handleDrop = (e, type) => {
        let files
        if (type === "inputFile") {
            files = [...e.target.files]
        } else {
            e.preventDefault()
            e.stopPropagation()
            setDragging(false)
            files = [...e.dataTransfer.files]
        }
        if (files?.length > count) {
            return
        }
        const allFilesValid = files.every((file) => {
            return formats.some((format) => file.type.endsWith(`/${format}`))
        })

        if (!allFilesValid) {
            FileRef.current.value = null
            setisInvalidFormat(true)
            setInvalidfileName(files?.length && files[0].name)
            clearRef.current = setTimeout(() => {
                resetUploader()
            }, 60000)
            return
        }
        return upload(files)
    }

    const convertExcelToJson = (data) => {
        const workbook = XLSX.read(data, { type: "array" })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const json = XLSX.utils.sheet_to_json(worksheet)
        return json
    }

    const readFileData = async (file, readers, totalfiles, totalSize, currentSize) => {
        return new Promise((resolve, reject) => {
            let previousloadSize = 0
            const reader = new FileReader()
            readers.push(reader)
            if( file?.type === "text/plain" )  
                reader.readAsText(file)
            else
                reader.readAsArrayBuffer(file)
            reader.onprogress = (data) => {
                if (data.lengthComputable) {
                    currentSize+= data.loaded - previousloadSize
                    previousloadSize = data.loaded
                    const progress = parseInt( ((currentSize / totalSize) * 100), 10 )
                    setprogress(progress)
                }
            }
            reader.onloadend = () => {
                let content = reader.result
                let completedCount = 0
                readers.forEach((reader) => {
                    if (reader.readyState == 2) {
                        completedCount+=1
                    }
                })
                if(totalfiles === completedCount) {
                    setisUploading(false)
                    setisuploadCompleted(true)
                }
                if (selectedFormat?.split(",").includes("Excel")) {
                    if( file?.type !== "text/plain" ) {
                        content = convertExcelToJson(content)
                    }
                }
                resolve(content)
            }
            reader.onerror = (error) => {
                reject(error)
            }
        })
    }

    const triggerUploader = () => {
        event.preventDefault()
        setIsUploadClicked && setIsUploadClicked(true)
        if (!isUploading && !isInvalidFormat && !isuploadCompleted) {
            FileRef.current.click()
        }
    }

    useEffect(() => {
        const handleDragOver = (e) => {
            e.preventDefault()
            e.stopPropagation()
            setDragging(true)
        }

        const handleDragLeave = (e) => {
            e.preventDefault()
            e.stopPropagation()
            setDragging(false)
        }
        if (!isInvalidFormat && !isUploading && !isuploadCompleted) {
            DropContainer.current.addEventListener("dragover", handleDragOver)
            DropContainer.current.addEventListener("drop", handleDrop)
            DropContainer.current.addEventListener("dragleave", handleDragLeave)
        } else {
            DropContainer.current.removeEventListener("dragover", handleDragOver)
            DropContainer.current.removeEventListener("drop", handleDrop)
            DropContainer.current.removeEventListener("dragleave", handleDragLeave)
        }

        return () => {
            if (DropContainer.current) {
                DropContainer.current.removeEventListener("dragover", handleDragOver)
                DropContainer.current.removeEventListener("drop", handleDrop)
                DropContainer.current.removeEventListener("dragleave", handleDragLeave)
            }
        }
    }, [fileData, isUploading, isInvalidFormat, isuploadCompleted])

    useEffect(() => {
        return () => clearTimeout(clearRef.current)
    }, [])
    const dragClass = `flex flex-col justify-center 
        items-center gap-[8px] self-stretch border rounded-xl w-full h-[80px] px-6`

    return (
        <>
            { /* Container Drop */ }
            <div className="flex flex-col gap-[4px] items-start w-full">
                <button onClick={ triggerUploader } className={ `${isCustomStyling ? "w-[63%]": "w-full"} flex flex-col items-start` } disabled={ disabled }>
                    <div className={ `${
                        dragging
                            ? "border-gray bg-white"
                            : "border-dashed border-lightGray bg-lightSkyblue"
                    } ${dragClass}` } ref={ DropContainer }
                    >
                        <div className="flex justify-center items-start gap-[24px] self-stretch w-full" >
                            <div className="flex items-start gap-[8px] flex-[1_0_0]">
                                <div className="flex justify-center items-center h-[24px] w-[24px]">
                                    <img
                                        src={ (isUploading == true || isInvalidFormat == true) ? 
                                            uploadIconInactive : isuploadCompleted ? fileIcon : uploadIcon }
                                        alt="upload"
                                        className="shrink-0 w-[20px] h-[20px]"
                                    ></img>
                                </div>
                                <div className="flex flex-col justify-center items-start gap-[4px] flex-[1_0_0]">
                                    <input
                                        className="opacity-0 hidden"
                                        type="file"
                                        multiple="true"
                                        ref={ FileRef }
                                        accept={ formats }
                                        onChange={ (e) => {
                                            handleDrop(e, "inputFile")
                                        } }
                                    />
                                    <div className="flex items-center gap-[16px]">
                                        <span className="text-secondary-50 text-center font-bold text-sm">
                                            { (isUploading || isuploadCompleted || isInvalidFormat) ? 
                                                ( validFileName || InvalidfileName) : uploaderLabel }
                                        </span>
                                        { isInvalidFormat === true && (
                                            <span className="text-secondary-200 font-normal text-xs">
                                                { t("common.uploaderremovallabel") }
                                            </span>
                                        )
                                        }
                                    </div>
                                    { !isUploading && (
                                        <div className="flex items-center gap-[4px]">
                                            { (isuploadCompleted === true || isInvalidFormat === true) && (
                                                <>
                                                    <div className={ `flex justify-center items-center gap-[10px] p-[10px]
                                                    w-[12px] h-[12px] shrink-0 rounded-full 
                                                    ${isInvalidFormat ? "bg-red": "bg-green"}` }>
                                                        <img
                                                            className={ "!max-w-[none] shrink-0" }
                                                            src={ isInvalidFormat == true ? info_white : tick_white }
                                                            alt={ isInvalidFormat == true ? "failure" : "Sucess" }
                                                        ></img>
                                                    </div>
                                                </>
                                            )
                                            }
                                            <span
                                                className={ `${isInvalidFormat ? "text-red": isuploadCompleted? 
                                                    "text-secondary-50": "text-secondary-200"} text-center 
                                                font-normal text-xs` }

                                            >
                                                { isInvalidFormat == true ? (t("common.UploadFailureText") + 
                                                    selectedFormat) : isuploadCompleted ?
                                                    t("common.UploadSucessText") : filesSupportLabel + " " + selectedFormat }
                                            </span>
                                        </div>
                                    ) }
                                    { isUploading && (
                                        <>
                                            <div className="flex items-center gap-[8px] self-stretch">
                                                <div className="flex flex-col h-[5px] items-start gap-[10px] 
                                                flex-[1_0_0] bg-lighterBlue rounded-[100px] w-full">
                                                    <div className={ "shrink-0 h-[5px] rounded-[100px] bg-primary-100" } 
                                                        style={ { width: `${progress}%` } }>
                                                    </div>
                                                </div>
                                                <label className="text-secondary-50 text-xs font-normal">
                                                    { progress + "%" }
                                                </label>
                                            </div>
                                        </>
                                    ) }
                                </div>
                            </div>
                            <div className="flex flex-col">
                                { !isUploading && !isInvalidFormat && !isuploadCompleted && (
                                    <button
                                        className="h-[26px] flex justify-center items-center 
                                        bg-transparent border border-solid hover:border-1 hover:border-primary-150 hover:bg-primary-150 
                                        border-blue font-normal text-xs px-3 outline-none focus:outline-none 
                                        rounded-full mr-1 mb-1 text-blue"
                                        type="button"
                                        disabled={ disabled }                                   
                                    >
                                        { t("common.uploaderButtonText") }
                                    </button>
                                ) }
                                { (isUploading || isInvalidFormat ||(!module && isuploadCompleted)) && (
                                    <button
                                        ref={ RemoveButton }
                                        className="flex justify-center items-center h-[16px] w-[16px] hover:border-1 hover:border-primary-100"
                                        type="button"
                                        onClick={ resetUploader }
                                    >
                                        <img
                                            src={ isuploadCompleted == true ? deleteIcon : closeIcon }
                                            alt={ isuploadCompleted == true ? t("common.uploadAltLabel") : t("common.uploadAltLabelTwo") }
                                            className="shrink-0 w-[12px] h-[12px]"
                                        ></img>
                                    </button>
                                ) }
                            </div>
                        </div>
                    </div>
                    { isUploading && (
                        <label className="text-center text-sm font-normal text-secondary-50">
                            { t("common.uploaderWaitText") }
                        </label>
                    ) }
                </button>
            </div>
            <ToastNotification />
        </>
    )
}

export default FileUploderWithDragandDrop
